import React from 'react';
import { IAllTransitions, TransitionMap } from '@agilepoint/utils-type';
import { TransitionType, TransitionFactory } from './types';

// type TransitionMapValue<T, V> = {
//     [K in keyof T]: V;
// };

export interface ITransitionStore<TAnimations extends
    TransitionMap<IAllTransitions> = TransitionMap<IAllTransitions>> {
    register<Args>(name: string, transition: TransitionFactory<Args>): void;
    apply<N extends keyof TAnimations>(name: N, config?: any): TransitionType<any> | undefined;
    getNames(): string[];
}

export function createTransitionStore<
    TAnimations extends TransitionMap<IAllTransitions> = TransitionMap<IAllTransitions>
>(): ITransitionStore<TAnimations> {

    const _transitions: TAnimations = {
    } as any;

    return {
        register: (name, transition) => {

            if ((_transitions as any)[name] === transition) {
                return;
            }
            Object.defineProperty(_transitions, name, {
                value: transition,
                enumerable: true,
                writable: false,
                configurable: true
            });
        },

        apply: (name, config) => {
            const factory: any = _transitions[name];
            return factory?.call(undefined, config);
        },
        getNames() {
            return Object.entries(_transitions).map(([key]) => key);
            // .reduce((prev, [name, value]) => {
            //     (prev as any)[name] = Object.keys(value);
            //     return prev;
            // }, {}) as any;
        }
    };
}

const TransitionStoreContext = React.createContext(createTransitionStore());

export const TransitionStore = TransitionStoreContext.Provider;

export const useTransitionStore = () => React.useContext(TransitionStoreContext);
